import {ComponentBase} from '../../../component-base';
import {IMouseDown, IDoubleClick} from '../Interfaces';
import {Injectable} from '@angular/core';
import {DrawingsHolderService} from '../drawings-holder.service';
import {PositionCalculatorService} from '../position-calculator.service';
import {common} from '../common';
import {Edge, IPost, Post, SelectableIntermediatePost} from '../object3D';
import {PostFactoryService} from '../post-factory.service';
import {ObbBuilder} from '../../collision/obb-builder.service';
import { SelectComponent } from '.';

declare let THREE: any;

@Injectable()
export class AddPicketComponent extends ComponentBase implements IMouseDown, IDoubleClick {
  dblclick(e: MouseEvent): boolean {
    
    this.selectComponent.enable();
    this.selectComponent.mouseUp(e);
    this.disable();
    return true;
  }

  private raycaster = new THREE.Raycaster(
    new THREE.Vector3(0, 0, 0),
    new THREE.Vector3(0, -1, 0)
  );
  public scaleCor;

  constructor(
    private drawings: DrawingsHolderService,
    private positionCalculator: PositionCalculatorService,
    private postFactory: PostFactoryService,
    private selectComponent: SelectComponent
  ) {
    super();
    this.scaleCor = 1;
  }

  private canPlace(post: IPost): boolean {

    const posts = this.drawings.canvas.children
      .filter(ch => ch instanceof SelectableIntermediatePost || ch instanceof Post);

    const postsOBB = posts.map(p =>
      new ObbBuilder()
        .setPosition(p.position.clone().setY(0))
        .setSize(new THREE.Vector3(p.getSize(), 0, p.getSize()))
        .build(p)
    );

    const addedPostOBB = new ObbBuilder()
      .setSize(new THREE.Vector3(post.getSize(), 0, post.getSize()))
      .build(post);

    return postsOBB.find(obb => obb.isIntersectionOBB(addedPostOBB)) === undefined;

  }

  mouseDown(e: MouseEvent): boolean {
    const point = this.positionCalculator.calculate(e).setY(common.raycastAtY);

    this.raycaster.ray.origin.copy(point);

    const edges = this.drawings.canvas.children.filter(ch => ch instanceof Edge);

    const intersection = this.raycaster.intersectObjects(edges);

    if (intersection.length !== 0) {
      const edgeMesh = intersection[0].object as Edge;

      const edge = edgeMesh.edge;
      const projected = point.setY(0).sub(edge.start).projectOnVector(edge.direction);

      const locked = edge.start.add(projected);

      const postInfo = Object.assign(locked);

      const post = this.postFactory.createPicket(postInfo, edge);
      post.position.copy(locked).setY(0);

      post.scaleCor = this.scaleCor;
      post.update();

      if (this.canPlace(post)) {
        this.drawings.canvas.add(post);
      }

      return true;
    }

    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/proTools/components/AddPicketComponent.ts